import { surgicalExpertiseMap } from "./surgicalExpertise";
import { patientMap } from "./patient";
import { teamMap } from "./team";
import { timestampsMap } from "./timestamps";
import { paginationMap } from "./pagination";

export const surgicalAttendanceMap: GenericObject = {
	patient_id: "patientId",
	attendance_id: "attendanceId",
	expertise_id: "expertiseId",
	surgical_team_id: "surgicalTeamId",
	surgical_bed_id: "surgicalBedId",
	surgery_date: "surgeryDate",
	procedure_size: "procedureSize",
	patient: patientMap,
	team: teamMap,
	expertise: surgicalExpertiseMap,
	...timestampsMap,
};

export const paginatedSurgicalAttendanceMap: GenericObject = {
	results: surgicalAttendanceMap,
	...paginationMap,
};
